import { postJson } from '@/utils/fetchOptions';

import { useAuthToken, useAuthUser } from './useAuth';
import { useMutation } from './useMutation';

interface UseSaveCampaignProps {
  email?: string;
  step: string;
  onSuccess: TypeAny;
}

interface UseSaveCampaignResponse {
  campaign: Api.CampaignData;
  userId: string;
}

export function useSaveCampaign({ email, step = '', onSuccess }: UseSaveCampaignProps) {
  const token = useAuthToken();
  const user = useAuthUser();

  const userId = user?.user_id || email;

  const {
    mutate,
    isLoading,
    data = {},
    error
  } = useMutation({
    mutationKey: `save-campaign-${userId}`,
    mutationFn: async () =>
      postJson({
        url: '/api/campaign/save',
        body: {
          userId,
          token
        }
      }).then((response: UseSaveCampaignResponse & ResponseObject) => {
        const currentSessionStorage = JSON.parse(sessionStorage.getItem('campaign') || '{}');

        const campaignObject = {
          current_step: step,
          campaign_id:
            currentSessionStorage.campaign_id || (step === 'brief' ? 'campaign-id' : undefined),
          campaign_name:
            currentSessionStorage.campaign_name || (step === 'brief' ? 'campaign-name' : undefined),
          brand:
            currentSessionStorage.brand ||
            (step === 'brand'
              ? {
                  brand_id: 'brand-id',
                  brand_name: 'brand-name',
                  brand_logo_url: 'logo-url'
                }
              : undefined),
          brief:
            currentSessionStorage.brief ||
            (step === 'brief'
              ? {
                  description: 'brief-description'
                }
              : undefined),
          platforms: currentSessionStorage.platforms || undefined,
          playlists: currentSessionStorage.playlists || undefined,
          user_id: response.userId,
          type: currentSessionStorage.type || undefined
        };

        sessionStorage.setItem('campaign', JSON.stringify(campaignObject));
        localStorage.setItem('campaign', JSON.stringify(campaignObject));

        return campaignObject;
      }),
    onSuccess
  });

  return {
    mutate,
    isLoading,
    error,
    data
  };
}
